import { render, staticRenderFns } from "./VorlagePromotionsstrukturNotenuebersicht.vue?vue&type=template&id=5345c71c"
import script from "./VorlagePromotionsstrukturNotenuebersicht.vue?vue&type=script&lang=js"
export * from "./VorlagePromotionsstrukturNotenuebersicht.vue?vue&type=script&lang=js"
import style0 from "./VorlagePromotionsstrukturNotenuebersicht.vue?vue&type=style&index=0&id=5345c71c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports